import $ from 'jquery';

const checkProductCoupon = (productId, productIds) => {
  if (productIds !== null) {
    for (let id = 0; id < productIds.length; id++) {
      if (parseInt(productIds[id], 10) === productId) {
        return true;
      }
    }
    return false;
  } else {
    return true;
  }
};

export { checkProductCoupon };
